module.exports = __webpack_public_path__ + "img/whatsapp_logo.4bfcb885.png";